(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/jupiterfetcher/assets/javascripts/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/utils/jupiterfetcher/assets/javascripts/handlebarshelpers.js');
(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    function checkErrors(model, errors, all) {
      var i = errors.length;
      var result = false;

      if (
        errors.length &&
        model &&
        model.dataError &&
        Object.prototype.hasOwnProperty.call(model, 'errorCodes')
      ) {
        while (i--) {
          if (Object.prototype.hasOwnProperty.call(model.errorCodes, errors[i])) {
            result = true;
            if (!all) {
              break;
            }
          } else {
            result = false;
            if (all) {
              break;
            }
          }
        }
      }

      return result;
    }

    hbs.registerHelper('hasAllErrors', function() {
      var options = arguments[arguments.length - 1];

      if (
        checkErrors(
          arguments[0],
          Array.prototype.slice.call(arguments, 1, arguments.length - 1),
          true
        )
      ) {
        return options && typeof options.fn === 'function' ?
          options.fn(this) :
          true;
      }
      return options && typeof options.inverse === 'function' ?
          options.inverse(this) :
          false;
    });

    hbs.registerHelper('hasError', function() {
      var options = arguments[arguments.length - 1];

      if (
        checkErrors(
          arguments[0],
          Array.prototype.slice.call(arguments, 1, arguments.length - 1),
          false
        )
      ) {
        return options && typeof options.fn === 'function' ?
          options.fn(this) :
          true;
      }
      return options && typeof options.inverse === 'function' ?
          options.inverse(this) :
          false;
    });
  }
})();


 })(window);